"use client";

import { useEffect } from "react";
import { useAppSettingsStore } from "@/lib/store/app-settings-store";
import {
  applyColorTheme,
  normalizeColorTheme,
  subscribeToSystemColorScheme,
} from "@/lib/color-theme";

/**
 * 配色テーマ (AppSettings.colorTheme) と DOM を突き合わせる。描画はしない。
 *
 * - 設定が読み込めたら `<html>` のクラスに反映する
 *   → Web で選んだテーマが user_settings 経由でデスクトップにも乗る
 *     (localStorage はオリジンが別なので Web ⇄ Tauri で共有されない)
 * - `system` を選んでいる間は OS の切り替えに追随する
 *
 * ペイント前の復元は app/layout.tsx のインラインスクリプト (localStorage ミラー)
 * が行うので、ここは設定が読み込めるまで DOM に触らない。触ると
 * 「起動直後に一瞬ダークへ戻ってからライトになる」ちらつきになる。
 *
 * 表示倍率 (components/display-zoom-sync.tsx) と同じ役割分担。
 */
export function ThemeSync() {
  const colorTheme = useAppSettingsStore((s) => s.settings.colorTheme);
  const isLoaded = useAppSettingsStore((s) => s.isLoaded);

  useEffect(() => {
    if (!isLoaded) return;
    applyColorTheme(colorTheme);
  }, [colorTheme, isLoaded]);

  useEffect(() => {
    if (!isLoaded) return;
    if (normalizeColorTheme(colorTheme) !== "system") return;
    return subscribeToSystemColorScheme(() => {
      applyColorTheme("system");
    });
  }, [colorTheme, isLoaded]);

  return null;
}
